import { EmployeesOverview } from '../translations-types';

const translations: EmployeesOverview = {
  addEmployee: 'Toevoegen medewerker',
};

export default translations;
